import React, { FC, useEffect } from "react";
import { RadionPackagingProps } from "./interface";


const RadionPackaging: FC<RadionPackagingProps> = ({
  isEditing,
  ItemMultiplo,
  isOrderStatus,
  sequenceNumber,
  sequenceBudget,
  radionPackaging,
  setRadionPackaging,
  setQuantityPackaging,
  conversionFactorValue,
  setIsKitPackagingActive
}) => {
  const packgingName = `packagingQts${sequenceNumber}${sequenceBudget}`;
  let ItemMultiploName = "Kit";
  if (ItemMultiplo === 1) {
    ItemMultiploName = "Kit";
  }
  else {
    ItemMultiploName = "Kit [múltiplo de " + ItemMultiplo + "]*";
  }

  function activeEmbalagem() {
    setRadionPackaging(0);
    setQuantityPackaging(conversionFactorValue);
    setIsKitPackagingActive(false);
  }
  function activekit() {
    setRadionPackaging(1);
    setQuantityPackaging(ItemMultiplo * conversionFactorValue);
    setIsKitPackagingActive(true);
  }

  useEffect(() => {
    if (radionPackaging === 1) {
      setQuantityPackaging(ItemMultiplo * conversionFactorValue);
      setIsKitPackagingActive(true);
    } else if (radionPackaging === 0) {
      setQuantityPackaging(conversionFactorValue);
      setIsKitPackagingActive(false);
    }
  }, [conversionFactorValue]);

  return (
    <div className="radioArea">
      <span className="subtitle">Qtd. da Embalagem por:</span>
      <div className="inputArea">
        <div className={!isEditing ? "selectDisabled" : "select"}>
          <input
            type="radio"
            id="packaging"
            name={packgingName}
            defaultChecked={radionPackaging === 0}
            value={radionPackaging}
            onClick={() => activeEmbalagem()}
            disabled={isOrderStatus || !isEditing ? true : false}
          />
          <label htmlFor="packaging">Embalagem</label>
        </div>
        <div className={ItemMultiplo === 1 || !isEditing ? "selectDisabled" : "select"}>
          <input
            type="radio"
            id="kit"
            name={packgingName}
            defaultChecked={radionPackaging === 1}
            value={radionPackaging}
            onClick={() => activekit()}
            disabled={isOrderStatus || ItemMultiplo === 1 || !isEditing ? true : false}
          />
          <label htmlFor="kit">{ItemMultiploName}</label>
        </div>
      </div>
    </div>
  );
};
export default RadionPackaging;